<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-11 11:58:36
-->
<template>
    <div></div>
</template>

<script setup>
    import { onBeforeMount,ref, reactive, onMounted,h } from "vue";
    import { useRouter } from 'vue-router';
    import jwt_decode from "jwt-decode";
    import { Message, Modal } from '@arco-design/web-vue';
    import { useI18n } from 'vue-i18n';
    import { LoginApi } from '@/api/LoginApi.js';
    import { RoleApi } from '@/api/RoleApi.js';

    console.log(import.meta.env,'环境22')
    const BASE_URL = import.meta.env.MODE == 'development'
                ? 'http://127.0.0.1:8080/#/feishuLogin'  // 本地开发环境 
                // : `http://mobile.gobao.cn/hepha/#/feishuLogin`  // 测试应用
                : `https://oms.hepha.com/#/feishuLogin`    // 生产应用

    const router = useRouter()
    const { t } = useI18n()

    onBeforeMount(()=>{
            let redirectUrl = window.location.href;
            let isRedirectUrl = redirectUrl.indexOf("code") === -1;
            let url = ''

            if (isRedirectUrl) {
                let redirectUrl = encodeURIComponent(`${BASE_URL}`);
                let host = window.location.host
                // 测试应用feishu：cli_a37edc434cb8500c    
                // 生产应用lark：cli_a45a2c9266b8d02e
                // 测试应用feishu："https://open.feishu.cn/open-apis/authen/v1/index";    
                // 生产应用lark："https://open.larksuite.com/open-apis/authen/v1/index"
                let appid = host == 'mobile.gobao.cn'? 'cli_a37edc434cb8500c' : 'cli_a45a2c9266b8d02e'
                let oauthPath = host == 'mobile.gobao.cn'? "https://open.feishu.cn/open-apis/authen/v1/index" : "https://open.larksuite.com/open-apis/authen/v1/index";
                url = oauthPath + "?app_id=" + appid + "&redirect_uri=" + redirectUrl;
                window.location.href = url;  
            } else {
                // let index_f = redirectUrl.indexOf("code=");
                // let index_s = redirectUrl.indexOf("&state=");
                // let feishuCode = redirectUrl.slice(index_f + 5, index_s);

                const url = new URL(redirectUrl)
                const feishuCode = url.href.split('code=')[1]

                login({
                    code:feishuCode
                })
                async function login (param){
                    let res = await LoginApi.getInstance().feishuLogin(param)
                    if(res.code == 0){
                        let userInfo = jwt_decode(res.access_token)
                        userInfo.role = userInfo.role.join(',')
                        sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
                        sessionStorage.setItem('token',res.access_token)
                        getMenuBtnByRole(userInfo)
                    }else{
                        Modal.error({
                            title: t('base.tip'),
                            content: h('div', {}, [
                                h('div', `${t('login.feishuLoginError')}：${res.msg}`),
                                h('div', `${t('login.backFeishuLogin')}`),
                            ]),
                            onOk() {
                                window.location.href = url;  
                            },
                        });
                    }
                }

                // 角色按钮权限控制
                async function getMenuBtnByRole(userInfo) {
                    let role = userInfo.role
                    let res = await RoleApi.getInstance().getMenuBtnByRole(role)
                    if (res.code == 0) {
                        let btnData = [], menuId = []
                        res.data.forEach(i => {
                            i.menu.forEach(k => {
                                if (k.menu_category == 2) {
                                    btnData.push(k)
                                }
                            })
                            i.menuId.forEach(k => {
                                if (!menuId.includes(k)) {
                                    menuId.push(k)
                                }
                            })
                        })

                        let permissionBtns = [], arr = []
                        btnData.forEach(i => {
                            if (menuId.includes(i.id)) {
                                permissionBtns.push(i.menu_name)
                            }
                        })
                        permissionBtns.forEach(i => {
                            if (!arr.includes(i)) {
                                arr.push(i)
                            }
                        })
                        sessionStorage.setItem('permissionBtns', JSON.stringify(arr))
                        router.replace('/OrderList/OrderList')
                    } else {
                        Message.error(res.msg)
                    }
                }
            }
    })
</script>

<style lang="less" scoped>

</style>